import React from 'react';

/**
 * Check animado de sucesso: o círculo faz um "pop", o traço do check é desenhado
 * e por fim um anel percorre a borda — one-shot ao montar. Reaproveita a animação
 * da tela WhatsApp ("WhatsApp Conectado!") para dar um feedback consistente nas
 * telas de sucesso do fluxo de onboarding/senha.
 *
 * Respeita prefers-reduced-motion: sem animação, mostrando direto o estado final.
 * `className` extra vai no wrapper (ex.: espaçamento específico da tela).
 */
export default function AnimatedCheck({ className = '' }) {
  return (
    <div className={`mx-auto mb-4 ${className}`}>
      <style>{`
        @keyframes wa-check-pop { 0%{transform:scale(0.5);opacity:0;} 60%{transform:scale(1.08);opacity:1;} 100%{transform:scale(1);} }
        @keyframes wa-check-draw { to { stroke-dashoffset: 0; } }
        @keyframes wa-check-ring { to { stroke-dashoffset: 0; } }
        .wa-check-pop { animation: wa-check-pop 0.4s cubic-bezier(0.22, 1, 0.36, 1) both; }
        .wa-check-draw { stroke-dasharray: 24; stroke-dashoffset: 24; animation: wa-check-draw 0.4s ease-out 0.25s forwards; }
        .wa-check-ring { stroke-dasharray: 239; stroke-dashoffset: 239; animation: wa-check-ring 0.5s ease-out 0.65s forwards; }
        @media (prefers-reduced-motion: reduce) {
          .wa-check-pop { animation: none; }
          .wa-check-draw { animation: none; stroke-dashoffset: 0; }
          .wa-check-ring { animation: none; stroke-dashoffset: 0; }
        }
      `}</style>
      <div className="wa-check-pop relative w-20 h-20 rounded-full bg-teal-100 flex items-center justify-center mx-auto">
        <svg className="absolute inset-0 w-full h-full -rotate-90 text-teal-600" viewBox="0 0 80 80" fill="none" aria-hidden="true">
          <circle className="wa-check-ring" cx="40" cy="40" r="38" stroke="currentColor" strokeWidth={3} strokeLinecap="round" />
        </svg>
        <svg className="w-10 h-10 text-teal-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path className="wa-check-draw" d="M20 6 9 17l-5-5" />
        </svg>
      </div>
    </div>
  );
}
